import React from 'react';
import {Text} from 'react-native';
import PropTypes from 'prop-types';

import globalStyles from '../../../styles';

const CustomText = (props) => {
  const {style, disabled, children, ...rest} = props;
  return (
    <Text
      style={[
        globalStyles.regular,
        {color: '#4A4A49', display: 'inline'},
        style,
        disabled && {opacity: 0.4},
      ]}
      {...rest}>
      {children}
    </Text>
  );
};

CustomText.propTypes = {
  style: PropTypes.any,
  disabled: PropTypes.bool,
  children: PropTypes.any,
};

export default CustomText;
